module.exports = __webpack_public_path__ + "static/media/Kavitha.f0446a67.png";